import React from 'react';
import { Text } from '@amzn/stencil-react-components/text';
import { Expander } from '@amzn/stencil-react-components/expander';

export const ProductivitySupportCurrentWeekFAQSet: React.FunctionComponent = () => {
  return (
    <>
      <Expander titleText="What is UPH?">
        <Text>
          (Units Per/Hours) is the amount of units or containers an individual processes in one hour.
        </Text>
      </Expander>
    </>
  );
}
